import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BrandingConfigurationService } from '@ptl/brand';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { ExactTargetResponse } from '../../passive-referral-loader/services/passive-referral-loader.service';
import { ApplicationRecord } from '../../interfaces/application-record.interface';

@Injectable({
  providedIn: 'root'
})
export class AssignReferralService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private brandService: BrandingConfigurationService
  ) { }

  assignReferral(appTrackingId: string, referralId: string) {
    const referralIdAsNumber = Number(referralId);
    const payload = {
      "payload": {
        "appTrackingId": appTrackingId,
        "referralId": referralIdAsNumber
      }
    };

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: '/sxesvc/api/v3/referralApp/assignReferral',
      POST_OR_PUT_PAYLOAD: payload,
      contentType: 'force_undefined',
      headers: new HttpHeaders({
        ddToken: this.brandService.getCurrentBrand().ddToken_encoded(),
      }),
      strategyConfigs: { forceModernUrl: true }
    });
    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }

  async assignReferralId(response: ExactTargetResponse, applicationRecord: ApplicationRecord) {
    const referralId = response.payload.referralId;
    await this.assignReferral(applicationRecord.applicationTrackingId, referralId);
  }
}
